/** Dữ liệu parse từ mã QR trên CCCD gắn chip. */
export interface CccdParsedData {
  name?: string;
  cccd?: string;
  dateOfBirth?: string;
  address?: string;
  phone?: string;
  engine?: string;
}

export function hasParsedCccdData(parsed: CccdParsedData): boolean {
  return Boolean(parsed.name || parsed.cccd || parsed.dateOfBirth || parsed.address || parsed.phone);
}

export function countParsedFields(parsed: CccdParsedData): number {
  return [parsed.name, parsed.cccd, parsed.dateOfBirth, parsed.address, parsed.phone].filter(Boolean).length;
}

export function normalizeDateForInput(value?: string): string {
  if (!value) return '';
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return value;

  const match = value.match(/(\d{1,2})[\/\-.](\d{1,2})[\/\-.](\d{4})/);
  if (!match) return '';

  const [, day, month, year] = match;
  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
}
